import logo1998 from "../../assets/img/historicEvents/LogoOverTheEdge/1998.png";
import logo1999 from "../../assets/img/historicEvents/LogoOverTheEdge/1999.png";

export const overTheEdgeDetail = {
  "over-the-edge": {
    id: "over-the-edge",
    title: "Over the Edge",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "over-the-edge",
        items: [
          {
            id: "over-the-edge-1998",
            title: "Over the Edge",
            description: "In Your House 1998",
            imgUrl: logo1998,
          },
          {
            id: "over-the-edge-1999",
            title: "Over the Edge",
            description: "Evil is once perceived... 1999",
            imgUrl: logo1999,
          },
        ],
      },
    ],
  },
};
